var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-editer"},[_c('textarea',{ref:"textareaRef",domProps:{"value":_vm.value},on:{"focus":function($event){return _vm.handleFocus(true)},"blur":function($event){return _vm.handleFocus(false)},"input":_vm.handleChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }